import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Color from 'color';
import { Link } from 'gatsby';
import { theme, media, color } from '../theme';
import { useSize, vr } from '../utils';

export function TableOfContents({ content, title, ordered, id, isSubpage }) {

  const SubpagesHeading = isSubpage
    ? <h3><Link to="..">{title}</Link></h3>
    : <h3>{title}</h3>;

  return (
    <Container
      id={id}
      ariaLabel={title}
      className="pageHasFeaturedImage"
    >
      {SubpagesHeading}
      <ul className={ordered ? 'ordered' : 'unordered'}>
        { content.map((item, index) => (
          <li key={`toc${index}`}><Link to={item.url} title={`Gå til ${item.title}`} activeClassName="active">{item.title}</Link></li>
        ))}
      </ul>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  margin: ${vr(0.5)} 0 ${vr(1)};
  box-sizing: border-box;
  font-size: .9em;
  /* padding: ${vr(1)} ${vr(0.25)};
  background: ${color.white};
  box-shadow: ${theme.containerShadow}; */
  /* border: 1px solid ${Color(color.gold).alpha(0.2)}; */

  &#subpages {
    
    ul {
      background: ${theme.navItemBackgroundColor};
      padding: 0;
      border: 1px solid ${theme.navItemBorderColor};
      border-bottom-width: 0;
      margin: 0;

      li {
        border-bottom: 1px solid ${theme.navItemBorderColor};
        opacity: 1;

        &:before {
          display: none;
        }

        a {
          display: block;
          padding: 0 16px;
          line-height: 48px;
          font-size: 1em;
          color: ${color.brown};
          text-decoration: none;
          position: relative;
          font-weight: 499;
          
          &.active {
            font-weight: 600;
            color: ${theme.navItemColorFocus};
          }
          
          &.active, &:hover {
            background: ${theme.navItemBackgroundColorFocus};
          }

          &:after {
            content: "";
            display: inline-block;
            position: absolute;
            top: 0;
            right: 0;
            width: 48px;
            height: 48px;
            background: ${theme.navItemRightArrowBackgroundColor} url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjwhRE9DVFlQRSBzdmcgIFBVQkxJQyAnLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4nICAnaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkJz48c3ZnIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMyIDMyIiBoZWlnaHQ9IjMycHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMycHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxwYXRoIGQ9Ik0yNC4yOTEsMTQuMjc2TDE0LjcwNSw0LjY5Yy0wLjg3OC0wLjg3OC0yLjMxNy0wLjg3OC0zLjE5NSwwbC0wLjgsMC44Yy0wLjg3OCwwLjg3Ny0wLjg3OCwyLjMxNiwwLDMuMTk0ICBMMTguMDI0LDE2bC03LjMxNSw3LjMxNWMtMC44NzgsMC44NzgtMC44NzgsMi4zMTcsMCwzLjE5NGwwLjgsMC44YzAuODc4LDAuODc5LDIuMzE3LDAuODc5LDMuMTk1LDBsOS41ODYtOS41ODcgIGMwLjQ3Mi0wLjQ3MSwwLjY4Mi0xLjEwMywwLjY0Ny0xLjcyM0MyNC45NzMsMTUuMzgsMjQuNzYzLDE0Ljc0OCwyNC4yOTEsMTQuMjc2eiIgZmlsbD0iIzUxNTE1MSIvPjwvc3ZnPg==) center center no-repeat;
            background-size: 40%;
          }
        }
      }
    }
  }

  h3 {
    /* margin: 0 calc(${theme.listMarginHorizontal} + ${theme.listItemCounterOffset}) ${vr(0.25)}; */
    margin: 0 0 ${vr(0.25)} 0;

    a {
      font-weight: inherit;

      &:after {
        display: none;
      }
    }
  }
  
  ul {
    /* margin: 0; */
    margin-top: 0;
    margin-bottom: 0;
    margin-left: ${vr(0.5)};

    li {
      padding-right: 0;
      opacity: .8;
      list-style: none outside;

      &:hover {
        opacity: 1;
      }

      &:before {
        content: "•";
        font-weight: 600;
        display: inline-block;
        margin-right: 0.5em;
        margin-left: -0.9em;
      }
    }

    &.ordered li {
      list-style: decimal;

      &:before {
        display: none;
      }
    }
  }

  a {
    color: ${color.brown};
    text-decoration: none;
    font-weight: 400;

    &.active {
      font-weight: bold;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  @media ${media.desktopS} {
    width: 240px;
    width: 100%;
    float: none;
    max-width: 500px !important;
    padding-left: 0px;

    ul {
      margin-right: ${vr(0.25)};
      margin-bottom: ${vr(1)};
      /* margin-left: ${vr(1.5)}; */
    }

    &#subpages {
      width: calc(100% - 740px);
      float: right;
      max-width: 380px;
      padding-left: 30px;
    }
  }
`;

TableOfContents.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
  ordered: PropTypes.bool,
  id: PropTypes.string,
  isSubpage: PropTypes.bool,
};

TableOfContents.defaultProps = {
  content: [],
  title: '',
  ordered: false,
  id: '',
  isSubpage: false,
};
